import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { IconDefinition, faCheckCircle, faCircleMinus, faCircleXmark, faFolderClosed, faPen, faTriangleExclamation,faBullhorn, faEye, faEyeSlash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Tgr, Cmf, ClientMinuteRequestDTO, CompanyDebtorMinuteRequestResolutionDTO, FactoringOperationDTO, FilterMinutes, InvoiceOperationMinuteDTO, MinuteRequestDetailRealTimeDTO, MinuteRequestResolutionDTO, MinuteRequestSnapshotDTO, OwnersMinuteRequest, Warranties } from '../../../files-clients/sub-page/minutes/interface/minute-detail';
import { LegacyScoring } from '../../../files-clients/interface/legacy-scoring';
import { MinuteRequestKpiDTO } from '../../../files-clients/sub-page/minutes/interface/minute-request-kpis.interface';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { RealTimeMinuteService } from '../../../files-clients/sub-page/minutes/service/real-time-minute.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MinuteRequestService } from '../../../files-clients/sub-page/minutes/service/minute-request.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { TgrServiceService } from '../../../files-clients/service/tgr-service.service';
import { FilterMinuteService } from '../../../files-clients/sub-page/minutes/service/filter-minute.service';
import { ScoringIngeService } from '../../../files-clients/service/scoring-inge.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { environment } from 'src/environments/enviroments';
import Swal from 'sweetalert2';
import html2pdf from 'html2pdf.js';
import { filter, finalize, switchMap } from 'rxjs';
import { SendNotification } from 'src/app/layouts/full/interface/headers.interface';
import { FormularioFacturaFormulaComponent } from '../../../files-clients/modals/formulario-factura-formula/formulario-factura-formula.component';
import { DetalleTgrComponent } from '../../../files-clients/components/information/detalle-tgr/detalle-tgr.component';
import { DetalleIngeAdmComponent } from '../../../files-clients/components/information/detalle-inge-adm/detalle-inge-adm.component';
import { DetalleCmfComponent } from '../../../files-clients/components/information/detalle-cmf/detalle-cmf.component';
import { ModificarDescripcionComponent } from '../../../files-clients/modals/modificar-descripcion/modificar-descripcion.component';
import { DetalleFogapeComponent } from '../../../files-clients/components/information/detalle-fogape/detalle-fogape.component';
import { ChangeMinuteRequestLineModalComponent } from '../../../files-clients/sub-page/components/change-minute-request-line-modal/change-minute-request-line-modal.component';
import { AddOperationToMinuteViewModel, AddOrRemoveWarrantiesMinuteRequestDTO, AddWarrantiesToMinuteViewModel, ApproveCompaniesDebtorsRequestDTO, ChangeMinuteRequestLineDTO } from '../../../files-clients/sub-page/minutes/interface/minute-request.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { UpdateInvoiceOperationModalComponent } from '../../../invoice-operations/update-invoice-operation-modal/update-invoice-operation-modal.component';
import { AddInvoiceOperationToMinuteModalComponent } from './add-invoice-operation-to-minute-modal/add-invoice-operation-to-minute-modal.component';
import { AddWarrantiesToMinuteModalComponent } from './add-warranties-to-minute-modal/add-warranties-to-minute-modal.component';
import { ModalUpdateDurationMinuteComponent } from './modals/modal-update-duration-minute/modal-update-duration-minute.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Permissions } from 'src/app/common/permissions';
import { ManageMinuteRequestConditionsModalComponent, MinuteRequestConditionViewModel, ManageMinuteRequestConditionModalViewModel } from './modals/manage-minute-request-conditions-modal/manage-minute-request-conditions-modal.component';
import { WhatsappFireNotificationModalComponent } from '../whatsapp-fire-notification-modal/whatsapp-fire-notification-modal.component';

@Component({
  selector: 'app-new-minute',
  templateUrl: './new-minute.component.html',
  styleUrls: ['./new-minute.component.scss']
})
export class NewMinuteComponent {
  @ViewChild('htmlData', { static: false }) htmlData: ElementRef;
  public id = 0;
  public faIcons = {
    faCircleMinus,
    faTriangleExclamation,
    faBullhorn,
    faEye, faEyeSlash,faPlus

  };
  public iconAproved: IconDefinition = faCheckCircle;
  public iconReject: IconDefinition = faCircleXmark;
  public minuteRequestId: number = 0;
  public minuteRequestRealTime: MinuteRequestDetailRealTimeDTO | null = null;
  public minuteOwnersRequest: OwnersMinuteRequest[] | undefined;
  public minuteDebtorResolutions: Array<CompanyDebtorMinuteRequestResolutionDTO>;
  public rutUrl: number;
  public resolutionName: string;
  public disableHasConditionChk: boolean = false;
  public showButtons: boolean = true;
  public showReviewButtons: boolean = false;
  public showbtnCompletar: boolean = false;
  public hasDicomPermission: boolean;
  public pathUrlDicom: string = 'url';
  public legacyDataUser: LegacyScoring | null = null;
  public myAngularxQrCode: string = null;
  public isCompany: boolean;
  public operations: any;
  /**
   * Propiedad para contener los KPIs generados de la minuta
   */
  public minuteRequestKpi: MinuteRequestKpiDTO;
  /**
   * Propiedad de los datos del cliente de la minuta
   */
  public minuteRequestClient!: ClientMinuteRequestDTO;
  /**
   * Propiedad de los datos de la operacion de factoring que crea la minuta
   */
  public originalFactoringOperation: InvoiceOperationMinuteDTO;
  public minuteSnapshot: MinuteRequestSnapshotDTO;
  public minuteDebtors: CompanyDebtorMinuteRequestResolutionDTO[];
  public loadingMinute: boolean = false;
  public formFilter!: FormGroup;
  public icons = { faFolderClosed, faPen };

  //Datos Equifax
  public totalVehiculosAmount = 0;
  public totalPropidadesAmount = 0;

  //Datos Existencia Garantias y Operaciones
  public anyWarrantie = false; 
  public anyOperations = false;

  //Datos CMF
  public datosCMF: Cmf;

  //Datos Tgr
  public datosTgr: Tgr;

  //Path URl FileClient
  public pathInfoClient: string;

  constructor(
    private realTimeMinute: RealTimeMinuteService,
    private route: ActivatedRoute,
    private minuteRequestService: MinuteRequestService,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private authService: AuthService,
    private _location: Location,
    private fb: FormBuilder,
    private router: Router,
    private tgrService: TgrServiceService,
    private filter: FilterMinuteService,
    private scoringIngeService: ScoringIngeService,
    private notification: NotificationsService,
    private changeRut: ConfigRutService,
    private cdr: ChangeDetectorRef
  ) {
    this.formFilter = this.fb.group({
      search: [''],
    });
    this.minuteDebtorResolutions = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minuteDebtors = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minuteRequestKpi = {
      debtorsLast12Months: [],
      debtorsTop10: [],
      debtorsLast24Months: [],
      factoringByCesionarios: [],
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.id = params['id'] | 0;
      this.myAngularxQrCode =
        environment.urlRoot + '/dashboards/minuteQR?id=' + this.id;
      this.minuteRequestId = this.id;
      //this.getRealTimeInfoMinuteRequest(this.id);
      this.tgrService.getTgr;
      this.hasDicomPermission = this.authService.ValidateUserPermission(
        'RequestOwnerPermissions'
      );

      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log(isMobile, navigator.userAgent);
      const forceDesktop = this.route.snapshot.queryParamMap.get('forceDesktop');
      if (isMobile && forceDesktop != 'true') {
        this.router.navigateByUrl('/dashboards/minuteQR?id=' + this.id); 
      }

    });
    this.mostrarCargando();
  }

  ngAfterViewInit() {
    this.getRealTimeInfoMinuteRequest(this.id);
  }

  ngOnDestroy(): void {
    this.realTimeMinute.stopConnection();
  }

  public mostrarCargando() {
    Swal.fire({
      title: 'Cargando Minuta',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.loadingMinute = true;
        this.ocultarbtn();
      },
    });
  }

  public getRealTimeInfoMinuteRequest(minuteRequestId: number) {
    this.realTimeMinute.startConnection(minuteRequestId).then( () => {
      setTimeout(() => {
        this.realTimeMinute.receivedMinuteDetai$.subscribe({
          next: (response) => {
            console.log("Minuta: ", response);
            if (response) 
            {
              this.setMinuteRequestData(response);
              this.showHideReviewPreApprovedMinute(response);
              this.showHideResolutionButtons(response);
              this.loadingMinute = false;
              this.armorRedirect();
              if(!response.isClosed) {
                this.fetchDebtorResolutions();
              } else {
                this.minuteDebtors = response.snapshot.companyDebtorResolutions||[];
                this.minuteDebtorResolutions = response.snapshot.companyDebtorResolutions || [];
              }
              Swal.close();
            }
          }
        });
      }, 1000);
    });
  }

  public fetchDebtorResolutions() {
    this.realTimeMinute.receivedMinuteDebtorResolutions$.subscribe({
      next:(debtorResolutions) => {
        this.minuteDebtors = debtorResolutions;
        this.minuteDebtorResolutions = debtorResolutions;
      }
    })
  }

  filtro: FilterMinutes;
  filterDebtors(debtor: any) {
    const name = debtor.target.value;
    const filterMinute = this.filter.filterDealsOpportunities(
      this.minuteDebtorResolutions,
      name
    );
    this.minuteDebtors = filterMinute;
  }

  public accessButton() {
    const permissionsUsers = this.authService
      .getUserPermissions()
      .filter((e) => {
        return e.includes('UpdateClient');
      });
    if (permissionsUsers.length > 0) {
      this.showButtons = true;
    } else {
      this.showButtons = false;
    }
  }

  public ocultarbtn() {
    if (this.minuteRequestRealTime?.finalResolutionName == 'Eliminada') {
      this.showbtnCompletar = false;
      console.log(this.showbtnCompletar);
    }
  }

  public showHideResolutionButtons(minuteRequest: MinuteRequestDetailRealTimeDTO){
    // No mostrar botones de resolucion si no esta pendiente o en comite
    if(!(minuteRequest.finalResolution === 1 || minuteRequest.finalResolution === 9)){
      this.showButtons = false;
      return;
    }

    const userName = this.authService.getNameIdentifier();
    const isAlreadyProvided = minuteRequest.resolutions
    .findIndex(r => r.userName == userName);
    if(isAlreadyProvided >= 0) {
      this.showButtons = false;
      return;
    }
    this.showButtons = true;
  }

  public hideButton(userResolution: MinuteRequestResolutionDTO[]) {
    const user = this.authService.getNameIdentifier();
    userResolution?.filter((response) => {
      const filtro = response.userName.includes(user);
      if (this.minuteRequestRealTime.finalResolutionName == 'Pendiente' || this.minuteRequestRealTime.finalResolutionName === 'En Comité'  && filtro == false) {
        this.showButtons = true;
      } else {
        this.showButtons = false;
      }
      if (this.minuteRequestRealTime.finalResolutionName == 'Aprobado') {
        this.showButtons = false;
      }
      if (this.minuteRequestRealTime.finalResolutionName == 'Rechazado') {
        this.showButtons = false;
      }
    });
  }

  public showHideReviewPreApprovedMinute(minuteRequest: MinuteRequestDetailRealTimeDTO) {
    const user = this.authService.getNameIdentifier();
    const isMinutePreApproved = minuteRequest?.finalResolution === 8;
    const hasPermission = this.authService.getUserPermissions().includes(Permissions.ReviewMinuteSpecialCondition);
    this.showReviewButtons = isMinutePreApproved && hasPermission;
  }

  public setMinuteRequestData(realTimeMinute: MinuteRequestDetailRealTimeDTO) {
    if (!realTimeMinute) {
      console.error('realTimeMinute is null or undefined');
      return;
    }
  
    this.resolutionName = realTimeMinute.finalResolutionName;
    this.minuteRequestRealTime = realTimeMinute;
    this.operations = realTimeMinute.operations || [];
    
    if (realTimeMinute.snapshot) {
      const { minuteRequestKpi, client, originalOperation } = realTimeMinute.snapshot;
      this.minuteSnapshot = realTimeMinute.snapshot;
      this.setKpis(minuteRequestKpi);
      this.setMinuteClient(client);
      this.setMinuteFactoringOperation(originalOperation);
    } else {
      console.error('Snapshot is null or undefined');
      this.minuteSnapshot = null;
    }
  
    this.loadingMinute = false;
  
    if (this.minuteRequestClient && this.minuteRequestClient.fullRut) {
      this.isCompany = Number.parseInt(this.minuteRequestClient.fullRut.split('-')[0].replace(/\./g, '')) > 50000000;
    } else {
      this.isCompany = false;
      console.error('minuteRequestClient or fullRut is null or undefined');
      
    }
  }
  
  private getSnapshot(minuteRequestId: number) {
    this.minuteRequestService
      .getMinuteSnapshot(minuteRequestId)
      .pipe(finalize(() => (this.loadingMinute = false)))
      .subscribe({
        next: (response: MinuteRequestSnapshotDTO) => {
          this.minuteSnapshot = response;
          this.setKpis(response.minuteRequestKpi);
          this.setMinuteClient(response.client);
          this.setMinuteFactoringOperation(response.originalOperation);
        },
    });
  }

  public redirectToMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/pdf'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  private setKpis(minuteKpi: MinuteRequestKpiDTO) {
    this.minuteRequestKpi = minuteKpi;
  }

  private setMinuteClient(minuteClient: ClientMinuteRequestDTO) {
    this.minuteRequestClient = minuteClient;
    this.minuteOwnersRequest = minuteClient.owners;
    this.datosCMF = minuteClient.cmf;
    this.datosTgr = minuteClient.tgr;
    this.serializeBase64(this.minuteRequestClient?.fullRut);
    this.obtenerLegacyData(this.minuteRequestClient?.fullRut);
    this.changeColorCMF(this.datosCMF?.totalMorosa,"Morosa");
    this.changeColorCMF(this.datosCMF?.totalVencida,"Vencida");
    this.changeColorCMF(this.datosCMF?.totalCastigada,"Castigada");
    this.changeColorTGR(this.datosTgr?.amountMorosa,"Morosa");
    this.changeColorEquifax(minuteClient.dicom?.deudaDicom,"DeudaTotal");
    this.changeColorEquifax(parseInt(minuteClient.dicom?.puntaje),"Puntaje");
    this.changeColorEquifax(minuteClient.dicom?.totaL_ICOM,"Icom");
    this.changeColorEquifax(minuteClient.dicom?.totaL_BOLCOM,"Bcom");
    this.changeColorEquifax(minuteClient.dicom?.totaL_BED,"Bed");
    this.changeColorEquifax(minuteClient.dicom?.totaL_BOLAB,"Blab");
  }

  private setMinuteFactoringOperation(
    originalFactoringOperation: InvoiceOperationMinuteDTO
  ) {
    this.originalFactoringOperation = originalFactoringOperation;
  }

  public updateMinutes() {
    Swal.fire({
      text: 'Se estan actualizando los datos',
      icon: 'info',
      timerProgressBar: true,

      didOpen: () => {
        Swal.showLoading();
        this.minuteRequestService
          .updateMinuteSnapshot(this.minuteRequestId)
          .pipe(finalize(() => (this.loadingMinute = false)))
          .subscribe({
            next: (response: MinuteRequestSnapshotDTO) => {
              Swal.fire({
                title: 'Minuta actualizada',
                text: 'Se ha actualizado exitosamente los datos de la minuta',
                icon: 'success',
                showConfirmButton: true,
                confirmButtonText: 'Cerrar',
              });
            },
            error: (err) => {
              console.log('Error', err);
              Swal.fire({
                title: 'Error',
                text: 'No fue posible actualizar la minuta',
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: 'Cerrar',
              });
            },
          });
      },
    });
  }

  public alertNotification(action: string) {
    let rut;
    rut = this.changeRut.transformStringRut(this.minuteRequestClient.fullRut);
    const id = parseInt(this.authService.getRutUser());
    const request: SendNotification = {
      action,
      companyId: rut,
      date: new Date(),
      userId: id,
      idType: this.minuteRequestId,
      type: 1
    };
    this.notification
      .createNotifications(request)
      .subscribe((a) => console.log(a));
  }

  closeMinuteConfirmation() {
    Swal.fire({
      title: 'Enviar a comité',
      text: '¿Estás seguro que desea enviar esta minuta a comité?',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.sendMinuteToComitee(this.minuteRequestId);
        this.alertNotification('Minuta Pendiente');
      }
    });
  }

  public getDicomPartners() {
    if (!this.hasDicomPermission) {
      Swal.fire({
        title: 'Error',
        text: 'No posee los permisos necesarios para solicitar DICOM',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
      });
      return;
    }
    if (this.minuteOwnersRequest != undefined) {
      var partners = this.minuteOwnersRequest?.length ?? 0;
      var partnersCompleted = 0;
      for (let i = 0; i < partners; i++) {
        console.log("Owners: ", this.minuteOwnersRequest[i])
        this.scoringIngeService
          .getEquifaxReportScoring(
            this.minuteOwnersRequest[i].fullRut
              .replace('.', '')
              .replace('.', '')
          )
          .subscribe({
            next: (response) => {
              if (this.minuteOwnersRequest != undefined) {
                this.minuteOwnersRequest[i].dicom = response.totaL_DEBT_AMOUNT;
                this.minuteOwnersRequest[i].puntaje = response.puntaje;
              }
              partnersCompleted = partnersCompleted + 1;
              if (partnersCompleted == partners) this.updateMinutes();
            },
            error(error) {
              console.log('Error:', error);
            },
          });
      }
    }
  }

  private sendMinuteToComitee(minuteRequestId: number): void {
    this.minuteRequestService.sendMinuteRequestToComitee(minuteRequestId).subscribe({
      next: (response) => {
        this.toastrService.success(response.resultMessage);
      },
      error: (err) => {
        this.toastrService.error(err.error.resultMessage);
      },
    });
  }

  public formularioFacturaFormula() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form';
    dialogConfig.data = this.rutUrl;
    const dialogRef = this.dialog.open(
      FormularioFacturaFormulaComponent,
      dialogConfig
    );
  }

  public mostrarInforTgr() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form';
    dialogConfig.data = this.minuteRequestClient.fullRut;
    const dialogRef = this.dialog.open(DetalleTgrComponent, dialogConfig);
  }

  public mostrarInfoIngeSAGR() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form';
    dialogConfig.data = this.minuteRequestClient.legacyData;
    const dialogRef = this.dialog.open(DetalleIngeAdmComponent, dialogConfig);
  }

  public mostrarInforCmf() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form';
    dialogConfig.data = this.minuteRequestClient.fullRut;
    const dialogRef = this.dialog.open(DetalleCmfComponent, dialogConfig);
  }

  public mostrarActualizarDescripcion() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form';
    dialogConfig.data = this.minuteRequestId;
    dialogConfig.data = this.minuteRequestRealTime?.description;
    const dialogRef = this.dialog.open(ModificarDescripcionComponent,dialogConfig);
  }

  public displayInfoFogape() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'container_forms';
    dialogConfig.data = this.minuteRequestClient.fullRut;
    const dialogRef = this.dialog.open(DetalleFogapeComponent, dialogConfig);
  }

  public openMinuteRequestLine(lineType: number) {
    const request: ChangeMinuteRequestLineDTO = {
      minuteRequestId: this.minuteRequestId,
      requestedLine:
        lineType === 0
          ? this.minuteRequestRealTime.factoringLine
          : this.minuteRequestRealTime.warrantyLine,
      lineType: lineType,
    };

    const dialogRef = this.dialog.open(ChangeMinuteRequestLineModalComponent, {
      data: request,
      minWidth: '250px',
      width: '30vw',
      maxWidth: '30vw',
      maxHeight: '50vh',
    });

    dialogRef
      .afterClosed()
      .pipe(
        filter((request) => request),
        switchMap((request) =>
          this.minuteRequestService.updateMinuteRequestLine(request)
        )
      )
      .subscribe({
        next: (response) => {},
        error: (err) => {
          this.toastrService.error(err.error.resultMessage);
        },
      });
  }

  private getMinuteRequestKpi(minuteRequestId: number) {
    this.minuteRequestService.getMinuteRequestKpi(minuteRequestId).subscribe({
      next: (response) => {
        this.minuteRequestKpi = response;
      },
    });
  }

  public obtenerLegacyData(r: string) {
    const rut = r.replaceAll('.', '');
    this.minuteRequestService.getLegacyData(rut).subscribe({
      next: (response) => {
        this.legacyDataUser = response;
      },
      error: (error) => {
        console.log('Error: ', error);
      },
    });
  }

  public transformDayToMonth(days: number): number {
    return Math.floor(days / 30);
  }

  public approveMinute(id: number) {
    Swal.fire({
      icon: 'question',
      titleText: '¿Deseas Aprobar esta Minuta?',
      text: 'Ingresa algún comentario (Opcional)',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
    }).then((results) => {
      if (results.isConfirmed) {
        this.minuteRequestService.approveMinute(id, results.value).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'success',
              titleText: ' Minuta aprobada con exito',
              text: response.message,
            });
            this.getRealTimeInfoMinuteRequest(id);
            //this.alertNotification('Minuta Aprobada');
          },
          error: (error: HttpErrorResponse) => {
            Swal.fire({
              icon: 'error',
              titleText: ' Minuta no se pudo aprobar',
              text: error.error.message,
            });
          },
        });
      }
    });
  }
 
  public approveReviewMinute(id: number) {
    Swal.fire({
      icon: 'question',
      titleText: '¿Aprobar revisión de minuta?',
      text: 'Ingresa algún comentario (Opcional)',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },

    }).then((result) => {
      if(result.isConfirmed) {
        this.minuteRequestService.approveReviewMinute(id, result.value)
        .subscribe({
          next: (res) => {
            Swal.fire({
              icon: 'success',
              titleText: ' Minuta aprobada con exito',
              text: res.message,
            });
          },
          error: (err: HttpErrorResponse) => {
            Swal.fire({
              icon: 'error',
              titleText: ' Minuta no se pudo aprobar',
              text: err.error.message,
            });
          }
        })
      }
    })
  }

  public rejectMinute(id: number) {
    Swal.fire({
      icon: 'question',
      titleText: '¿Rechaza la Minuta?',
      text: 'Indica por que se rechaza la minuta',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Rechazar',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
    }).then((results) => {
      if (results.isConfirmed) {
        this.minuteRequestService.rejectMinute(id, results.value).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'info',
              titleText: ' Minuta rechazada con exito',
              text: response.message,
            });
            //this.alertNotification('Minuta Rechazada');
          },
          error: (error) => {
            Swal.fire({
              icon: 'error',
              titleText: ' Minuta no se pudo Rechazar',
              text: error.error.message,
            });
          },
        });
      }
    });
  }

  public removeInvoiceOperationToMinute(invoiceOperationId: bigint){
    Swal.fire({
      icon: 'question',
      title: '¿Desea quitar operación de factoring?',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      confirmButtonText: 'Quitar'
    }).then((r) => {
      if(r.isConfirmed){
        Swal.showLoading();
        this.executeRemoveInvoiceOperationToMinute(this.minuteRequestId, invoiceOperationId);
      }
    })
  }

  private executeRemoveInvoiceOperationToMinute(minuteRequestId: number, invoiceOperationId: bigint) {
    this.minuteRequestService.removeFactoringOperationMinute(minuteRequestId, invoiceOperationId)
    .subscribe({
      next:(res) => {
        Swal.fire({
          icon: 'success',
          titleText: res.resultMessage
        });
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          titleText: err.error.resultMessage
        });
      }
    })
  }
  
  public deleteMinute(idMinuta: any, estado: any) {
    if (estado == 'Aprobado') {
      Swal.fire({
        icon: 'question',
        titleText: 'Anular la Minuta?',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cerrar',
        confirmButtonText: 'Anular Minuta',
      }).then((results) => {
        if (results.isConfirmed) {
          this.minuteRequestService.deleteMinute(idMinuta).subscribe({
            next: (response) => {
              Swal.fire({
                icon: 'info',
                titleText: 'Minuta Anulada exitosamente',
              });
              //this.alertNotification('Minuta Anulada');
            },
            error: (error) => {
              Swal.fire({
                icon: 'error',
                titleText: 'Minuta no se pudo Anular',
                text: error.message,
              });
            },
          });
        }
      });
    } else {
      Swal.fire({
        icon: 'question',
        titleText: '¿Eliminar la Minuta?',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Eliminar',
      }).then((results) => {
        if (results.isConfirmed) {
          this.minuteRequestService.deleteMinute(idMinuta).subscribe({
            next: (response) => {
              this.ocultarbtn();
              Swal.fire({
                icon: 'info',
                titleText: ' Minuta eliminada con exito',
              });
           
              //this.alertNotification('Minuta Eliminada');
            },
            error: (error) => {
              Swal.fire({
                icon: 'error',
                titleText: ' Minuta no se pudo Eliminar',
                text: error.message,
              });
            },
          });
        }
      });
    }
  }

  public serializeBase64(rut: string) {
    this.pathUrlDicom = this.getReportUrl(rut);
  }

  public getReportUrl(rut: string): string {
    const rutformat = rut.replace(/\./g, '');
    const parametros = {
      Token: "IngeInternalApiKey55",
      Rut: rutformat
    };
    const jsonParametros = JSON.stringify(parametros);
    const base64Datos = window.btoa(jsonParametros);
    return `https://scoringreport.inge.cl/api/Equifax/HtmlEncodedReport/${base64Datos}`;
  }

  public updateInvoiceOperation(operation: FactoringOperationDTO) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '80vw';
    dialogConfig.height = '85vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = operation.invoiceOperationId;
    this.dialog.open(UpdateInvoiceOperationModalComponent, dialogConfig);
  }

  public OpenApproversModal(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '50vw';
    dialogConfig.height = '35vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = {
      minuteId: this.minuteRequestId,
      originator: this.minuteSnapshot.createdBy.userName,
      currentWarrantyLine: this.minuteRequestClient?.legacyData?.linea,
      newWarrantyLine: this.minuteRequestRealTime?.warrantyLine,
      factoringLine: this.minuteRequestRealTime?.factoringLine,
      clientName: this.minuteRequestClient?.name,
      warrantiesCount: this.minuteSnapshot.warranties.length,
      totalWarranties: this.minuteSnapshot.warranties.map(w => w.amount).reduce((a, b) => a + b, 0),
    };
    this.dialog.open(WhatsappFireNotificationModalComponent, dialogConfig);
  }

  public updateInvoiceWarranties(warrantie: Warranties) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '80vw';
    dialogConfig.height = '85vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = warrantie.warrantyId;
    this.dialog.open(UpdateInvoiceOperationModalComponent, dialogConfig);
  }

  public openManangeMinuteRequestConditions() {
    const info: ManageMinuteRequestConditionModalViewModel = {
      minuteRequestId: this.minuteRequestId,
      conditions: this.minuteRequestRealTime.specialConditions.map(
        c =><MinuteRequestConditionViewModel> {
          minuteRequestMinuteConditionId: c.minuteRequestMinuteConditionId,
          minuteConditionId: c.conditionId,
          description: c.description
        }
      )
    };
    this.dialog.open(ManageMinuteRequestConditionsModalComponent,{
      data: info,
      width: '50vw',
      maxWidth: '90vw',
      height: 'auto',
      panelClass: 'better-dialog-container'
    });
  }

  public openDialogToAddInvoiceOperations() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '80vw';
    dialogConfig.height = '65vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    const companyId: number = Number.parseInt(this.minuteRequestClient.fullRut.split('-')[0].replaceAll('.', ''));
    const viewModel: AddOperationToMinuteViewModel = {
      minuteRequestId: this.minuteRequestId,
      companyId: companyId
    };
    dialogConfig.data = viewModel;
    this.dialog.open(AddInvoiceOperationToMinuteModalComponent, dialogConfig);
  }

  public openDialogToAddWarranties() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '80vw';
    dialogConfig.height = '65vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    const companyId: number = Number.parseInt(this.minuteRequestClient.fullRut.split('-')[0].replaceAll('.', ''));
    const viewModel: AddWarrantiesToMinuteViewModel = {
      minuteRequestId: this.minuteRequestId,
      companyId: companyId,
      addedWarrantiesId: this.minuteSnapshot.warranties?.map(w => w.warrantyId)??[]
    };
    dialogConfig.data = viewModel;
    this.dialog.open(AddWarrantiesToMinuteModalComponent, dialogConfig);
  }

  public openModalNewDueDate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '24vw';
    dialogConfig.height = '18vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    const data = {
      minuteRequestId: this.minuteRequestId,
      newDateDuration: this.minuteRequestRealTime?.createdAt
    }
    dialogConfig.data = data;
    this.dialog.open(ModalUpdateDurationMinuteComponent, dialogConfig);
  }

  public approveAllDebtors(): void {
    // Obtener los deudores que no estan aprobados
    const debtorsToApproveIds = this.minuteDebtors
      .filter((p) => p.resolutionState !== 2)
      .map((p) => p.companyId);
    const request: ApproveCompaniesDebtorsRequestDTO = {
      minuteRequestId: this.minuteRequestId,
      companiesIds: debtorsToApproveIds,
    };
    this.minuteRequestService.approveCompaniesDebtorsMinute(request).subscribe({
      next: (res) => {
        this.toastrService.success(res.resultMessage);
      },
      error: (err) => {
        this.toastrService.error(err.error?.message || 'Ha ocurrido un error');
      },
    });
  }

  public canApproveAllDebtors(): boolean {
    const canApproveAll =
      this.minuteDebtors.filter((d) => d.resolutionState !== 2).length > 0;
    return canApproveAll;
  }

  public goBack() {
    this._location.back();
  }
 
  public createPdf(): void {
    Swal.fire({
      title: 'Cargando PDF...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    setTimeout(() => {
      const html = this.htmlData.nativeElement;
      const htmlBorde1 = html.querySelector('#borde1');
      const htmlBorde2 = html.querySelector('#borde2');
      const htmlbtnResolutions = html.querySelector('#btnResolutions');
      const htmlbtnVolver = html.querySelector('#btnVolver');
      const htmlDebtorMinute = html.querySelector('#htmlDebtorMinute');
      const htmlDebtorMinutePdf = html.querySelector('#htmlDebtorMinutePdf');
      htmlBorde2.classList.add('cardPdf');
      htmlBorde1.classList.add('cardPdf');
      htmlbtnResolutions.classList.add('oculto');
      htmlbtnVolver.classList.add('oculto');
      htmlDebtorMinute.classList.add('oculto');
      htmlDebtorMinutePdf.classList.add('mostrar');
  
      const documento = document.getElementById('htmlData');
  
      if (!documento) {
        console.error('Elemento htmlData no existente o null');
        return;
      }
  
      setTimeout(() => {
        html2pdf()
          .from(documento)
          .set(this.options)
          .toPdf()
          .get('pdf')
          .then((pdf) => {
            // pdf.addPage();
          })
          .set(this.options)
          .save("Minute N°" + this.minuteRequestId)
          .finally(() => {
            // Mostrar las secciones ocultas después de generar el PDF
            document.querySelectorAll('.desc_line').forEach((el: HTMLElement) => {
              el.style.display = 'flex';
            });
            document.querySelectorAll('.page2').forEach((el: HTMLElement) => {
              el.style.pageBreakBefore = 'always';
            });
            Swal.close();
            htmlBorde1.classList.remove('cardPdf');
            htmlBorde2.classList.remove('cardPdf');
            htmlbtnResolutions.classList.remove('oculto');
            htmlbtnVolver.classList.remove('oculto');
            htmlDebtorMinute.classList.remove('oculto');
            htmlDebtorMinutePdf.classList.remove('mostrar');
          });
      }, 1000);
    }, 500);
  }
  
  options = {
    margin: [10,15,10,15],
    filename: 'minuta.pdf',
    image: {
      type: 'jpeg',
      quality: '0.98',
    },
    pagebreak: { mode: 'avoid-all', after: '#finPage1, #finPage2' },
    html2canvas: {
      scale: 2,
      useCORS: true,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    },
    jsPDF: {
      unit: 'mm', format: 'a3',
      orientation: 'portrait',
    },
  };
  
  changeColorCMF(amount: number, tipoDeuda: string) {
    if(amount > 0 && tipoDeuda == "Morosa") {
      const html = this.htmlData.nativeElement;
      const htmlCMF = html.querySelector('#htmlCmfMorosa');
      htmlCMF.classList.add('change_color_red');
    }
    if(amount > 0 && tipoDeuda == "Vencida") {
      const html = this.htmlData.nativeElement;
      const htmlCMF = html.querySelector('#htmlCmfVencida');
      htmlCMF.classList.add('change_color_red');
    }
    if(amount > 0 && tipoDeuda == "Castigada") {
      const html = this.htmlData.nativeElement;
      const htmlCMF = html.querySelector('#htmlCmfCastigada');
      htmlCMF.classList.add('change_color_red');
    }
  }

  changeColorTGR(amount: number, tipoDeuda: string) {
    if(amount > 0 && tipoDeuda == "Morosa") {
      const html = this.htmlData.nativeElement;
      const htmlTGR = html.querySelector('#htmlTgrMorosa');
      htmlTGR.classList.add('change_color_red');
    }
  }

  changeColorEquifax(amount: number, tipoDato: string) {
    if(amount > 0 && tipoDato == "DeudaTotal") {
      const html = this.htmlData.nativeElement;
      const htmlEquifax = html.querySelector('#htmlEquifax');
      if (htmlEquifax) {
        htmlEquifax.classList.add('change_color_red_alone');
      } else {
        console.error('El elemento con id "htmlEquifax" no existe.');
      }
    }
    if(amount < 400 && tipoDato == "Puntaje") {
      const html = this.htmlData.nativeElement;
      const htmlEquifax = html.querySelector('#htmlEquifaxPuntaje');
      if (htmlEquifax) {
        htmlEquifax.classList.add('change_color_red_equifax');
      } else {
        console.error('El elemento con id "htmlEquifax" no existe.');
      }
    }
    if(amount > 0 && tipoDato == "Bcom") {
      const html = this.htmlData.nativeElement;
      const htmlEquifax = html.querySelector('#htmlEquifaxBcom');
      if (htmlEquifax) {
        htmlEquifax.classList.add('change_color_red_equifax');
      } else {
        console.error('El elemento con id "htmlEquifax" no existe.');
      }
    }
    if(amount > 0 && tipoDato == "Icom") {
      const html = this.htmlData.nativeElement;
      const htmlEquifax = html.querySelector('#htmlEquifaxIcom');
      if (htmlEquifax) {
        htmlEquifax.classList.add('change_color_red_equifax');
      } else {
        console.error('El elemento con id "htmlEquifax" no existe.');
      }
    }
    if(amount > 0 && tipoDato == "Bed") {
      const html = this.htmlData.nativeElement;
      const htmlEquifax = html.querySelector('#htmlEquifaxBed');
      if (htmlEquifax) {
        htmlEquifax.classList.add('change_color_red_equifax');
      } else {
        console.error('El elemento con id "htmlEquifax" no existe.');
      }
    }
    if(amount > 0 && tipoDato == "Blab") {
      const html = this.htmlData.nativeElement;
      const htmlEquifax = html.querySelector('#htmlEquifaxBlab');
      if (htmlEquifax) {
        htmlEquifax.classList.add('change_color_red_equifax');
      } else {
        console.error('El elemento con id "htmlEquifax" no existe.');
      }
    }
  }

  armorRedirect() {
    var companyId = this.changeRut.transformStringRut(this.minuteRequestClient?.fullRut)
    this.pathInfoClient = environment.urlRoot + '/dashboards/files-clients?client=' + companyId;
  }

  public removeWarrantiesFromMinute(warrantiesId: number[]) {
    const request: AddOrRemoveWarrantiesMinuteRequestDTO = {
      minuteRequestId: this.minuteRequestId,
      warrantiesId: warrantiesId
    };
    Swal.fire({
      icon: 'question',
      title: '¿Eliminar garantía(s)?',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Sí'
    }).then((r) => {
      if(r.isConfirmed){
        Swal.showLoading();
        this.sendRemoveWarrantiesFromMinuteRequest(request);
      }
    })
  }

  private sendRemoveWarrantiesFromMinuteRequest(request: AddOrRemoveWarrantiesMinuteRequestDTO) {
    this.minuteRequestService.removeWarrantiesFromMinute(request)
    .subscribe({
      next: (res) => {
        Swal.fire({
          icon:  'success',
          titleText: res.resultMessage,
        });
      },
      error: (err) =>  {
        Swal.fire({
          icon:  'error',
          titleText: err.error.resultMessage || 'Ha ocurrido un error',
        });
      }
    })
  }

  public canMarkMinuteRequestConditionAsWatched() {
    const hasPermission = this.authService.hasPermission('ReviewMinuteSpecialCondition');
    const isPreapproved = this.minuteRequestRealTime.finalResolution === 8;
    return hasPermission && isPreapproved;
  }

  /**
   * Metodo para validar el usuario puede aprobar la revision de minuta pre-aprobada
   */
  public canApproveMinuteRequestReview() {
    const hasPermission = this.authService.hasPermission('ReviewMinuteSpecialCondition');
    const isAllConditionsReviewed = this.minuteRequestRealTime?.specialConditions.filter(c => !c.isReviewed).length === 0;
    return hasPermission && isAllConditionsReviewed;
  }

  public processingMinuteConditions: bigint[] = [];

  public addMinuteConditionProcessing(minuteConditionRequestId: bigint) {
    this.processingMinuteConditions.push(minuteConditionRequestId);
  }

  public removeMinuteConditionProcessing(minuteConditionRequestId: bigint) {
    this.processingMinuteConditions = [...this.processingMinuteConditions.filter(c => c !== minuteConditionRequestId)];
  }
  public isConditionProcessing(minuteConditionRequestId: bigint) {
    return this.processingMinuteConditions.findIndex(c => c === minuteConditionRequestId) >= 0;
  }

  public checkboxMarkMinuteRequestConditionAsWatched(event: MatCheckboxChange, minuteRequestMinuteConditionId: bigint){
    const value = event.checked;
    this.addMinuteConditionProcessing(minuteRequestMinuteConditionId);
    this.minuteRequestService.markMinuteRequestConditionAsViewed(this.minuteRequestId, minuteRequestMinuteConditionId)
    .pipe(
      finalize(() => this.removeMinuteConditionProcessing(minuteRequestMinuteConditionId))
    )
    .subscribe({
      error:(err) =>{
        event.source.checked = !value;
        Swal.fire({
          icon: 'error',
          title: err.error.resultMessage || 'Ha ocurrido un error',
          allowEscapeKey: false,
          allowOutsideClick: false
        });
      }
    })
  }

  public removeMinuteConditionFromMinute(minuteRequestMinuteConditionId: bigint) {
    this.addMinuteConditionProcessing(minuteRequestMinuteConditionId);
    this.minuteRequestService.removeMinuteConditionFromMinuteRequest(this.minuteRequestId, minuteRequestMinuteConditionId)
    .pipe(
      finalize(() => this.removeMinuteConditionProcessing(minuteRequestMinuteConditionId))
    )
    .subscribe({
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: err.error.resultMessage || 'Ha ocurrido un error',
          allowEscapeKey: false,
          allowOutsideClick: false
        });
      }
    });
  }

  public markMinuteRequestConditionAsWatched(minuteRequestMinuteConditionId: bigint) {
    return this.minuteRequestService.markMinuteRequestConditionAsViewed(this.minuteRequestId, minuteRequestMinuteConditionId)
  }

  changeHasConditions(event: MatCheckboxChange){
    this.disableHasConditionChk = true;
    this.minuteRequestService.updateMinuteHasConditions(this.minuteRequestId)
    .pipe(
      finalize(() => this.disableHasConditionChk = false)
    )
    .subscribe({
      next:(res) => {
        Swal.fire({
          icon: 'success',
          title: res.resultMessage,
          allowEscapeKey: false,
          allowOutsideClick: false
        });
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: err.error.resultMessage || 'Ha ocurrido un error',
          allowEscapeKey: false,
          allowOutsideClick: false
        });
      }
    })
  }
  
}